/* eslint-disable */ import { assertString, attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaGrillW30Components = [
    attachComponent.withComponent(attributeSelectionComponent, 'variant', true).withEntity('LynxSedonaGrillW30').attach(memoEval((self)=>[
            self.variant
        ], (variant)=>({
            value: variant,
            options: [
                {
                    label: '1 ProSear & 1 SS Burner',
                    value: 'ProSear_SsBurner1'
                },
                {
                    label: '1 ProSear & 1 SS Burner & Rotisserie',
                    value: 'ProSear_SsBurner1_Rotisserie'
                }
            ]
        })), (state)=>{
        assertString(state.value);
        return {
            variant: state.value
        };
    })
];

//# sourceMappingURL=lynx-sedona-grill-w-30.js.map